export default __webpack_public_path__ + "static/media/cubeYellow.898789dc.png";